/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const JS_ERROR_TYPES_LOCALE_ID = Object.freeze({
  "js.errorType.none.msg": "Error",
  "js.errorType.rangeError.msg": "RangeError",
  "js.errorType.typeError.msg": "TypeError",
  "js.errorType.referenceError.msg": "ReferenceError",
  "js.errorType.missingArgError.msg": "MissingArgError",
  "js.errorType.numberOfArgsError.msg": "NumberOfArgsError",
  "js.errorType.invalidSetError.msg": "InvalidSetError",
  "js.errorType.invalidGetError.msg": "InvalidGetError",
  "js.errorType.outOfMemoryError.msg": "OutOfMemoryError",
  "js.errorType.notSupportedError.msg": "NotSupportedError",
  "js.errorType.notSupportedHFTError.msg": "NotSupportedHFTError",
  "js.errorType.notAllowedError.msg": "NotAllowedError",
  "js.errorType.generalError.msg": "GeneralError",
  "js.errorType.raiseError.msg": "RaiseError",
  "js.errorType.deadObjectError.msg": "DeadObjectError",
  "js.errorType.helpError.msg": "HelpError"
});

export const JS_AFORM_LOCALE_STR_ID = Object.freeze({
  IDS_GREATER_THAN: "IDS_GREATER_THAN",
  IDS_GT_AND_LT: "IDS_GT_AND_LT",
  IDS_LESS_THAN: "IDS_LESS_THAN",
  IDS_INVALID_MONTH: "IDS_INVALID_MONTH",
  IDS_INVALID_DATE: "IDS_INVALID_DATE",
  IDS_INVALID_DATE2: "IDS_INVALID_DATE2",
  IDS_INVALID_VALUE: "IDS_INVALID_VALUE",
  IDS_AM: "IDS_AM",
  IDS_PM: "IDS_PM",
  IDS_MONTH_INFO: "IDS_MONTH_INFO",
  IDS_DAY_INFO: "IDS_DAY_INFO"
});

export const JS_ERROR_TYPES = Object.freeze({
  NONE: 0,
  RANGE_ERROR: 1,
  TYPE_ERROR: 2,
  REFERENCE_ERROR: 3,
  MISSING_ARG_ERROR: 4,
  NUMBER_OF_ARGS_ERROR: 5,
  INVALID_SET_ERROR: 6,
  INVALID_GET_ERROR: 7,
  OUT_OF_MEMORY_ERROR: 8,
  NOT_SUPPORTED_ERROR: 9,
  NOT_SUPPORTED_HFT_ERROR: 10,
  NOT_ALLOWED_ERROR: 11,
  GENERAL_ERROR: 12,
  RAISE_ERROR: 13,
  DEAD_OBJECT_ERROR: 14,
  HELP_ERROR: 15
});

export const FIELD_TYPE = Object.freeze({
  TEXT: "text",
  MULTILINE_TEXT: "multiline-text",
  COMB: "comb",
  PASSWORD: "password",
  RICH_TEXT: "richtext",
  ATTACHMENT: "attachment",
  CHECKBOX: "checkbox",
  RADIO: "radiobutton",
  LIST: "listbox",
  DROPDOWN: "combobox",
  BUTTON: "button",
  DATE_TIME: "datetime",
  SIGNATURE: "signature",
  BARCODE: "barcode"
});

export const ZOOM_TYPE = Object.freeze({
  NO_VARY: "NoVary",
  FIT_PAGE: "FitPage",
  FIT_WIDTH: "FitWidth",
  FIT_HEIGHT: "FitHeight",
  FIT_VISIBLE_WIDTH: "FitVisibleWidth",
  PREFERRED: "Preferred",
  REFLOW_WIDTH: "ReflowWidth"
});

export const JS_OPERATIONS = Object.freeze({
  GET_FIELD: "getField",
  MODIFY_FIELD: "modifyField",
  GET_ANNOT: "getAnnot",
  MODIFY_ANNOT: "modifyAnnot",
  PRINT: "print",
  ZOOM: "zoom",
  REMOVE_FIELD: "removeField"
});

export const JS_APIS = Object.freeze({
  GET_FIELD: "getField",
  SET_FIELD: "setField",
  GET_BUTTON_CAPTION: "getButtonCaption",
  GET_BUTTON_ICON: "getButtonIcon",
  GET_PAGE_NUM_WORDS: "getPageNumWords",
  ADD_ICON: "addIcon",
  GET_ANNOT: "getAnnot",
  SET_ANNOT: "setAnnot",
  GET_ANNOTS: "getAnnots",
  IS_DEFAULT_CHECKED: "isDefaultChecked",
  GET_ITEM_AT: "getItemAt",
  IS_BOX_CHECKED: "getIsBoxChecked",
  CHECK_THIS_BOX: "checkThisBox",
  DEFAULT_IS_CHECKED: "defaultIsChecked",
  GET_NTH_FIELD_NAME: "getNthFieldName",
  GET_PAGE_NTH_WORD: "getPageNthWord",
  GET_ICONS: "getIcons",
  GET_NUM_FIELDS: "getNumFields",
  GOTO_NAMED_DEST: "goToNamedDest",
  GET_RECT: "getRect",
  SET_RECT: "setRect",
  SET_ZOOM: "setZoom",
  SET_BASE_URL: "setBaseUrl",
  REMOVE_FIELD: "removeField",
  RESET_FORM: "resetForm",
  SUBMIT_FORM: "submitForm"
});

export const FEATURE = Object.freeze({
  PRINT: "print",
  READ_ONLY_DISABLED: "readOnlyDisabled",
  COMMENTS: "comments",
  ACROFORM: "acroform",
  ZOOM: "zoom"
});

export const JS_EXTERNAL_EVENT_TYPE = "External";

export const FIELD_DISPLAY_CODES = Object.freeze({
  VISIBLE: 0,
  HIDDEN: 1,
  NO_PRINT_VISIBLE: 2,
  PRINT_NO_VISIBLE: 3
});

export const FIELD_BORDER_STYLE = Object.freeze({
  SOLID: "solid",
  DASHED: "dashed",
  BEVELED: "beveled",
  INSET: "inset",
  UNDERLINE: "underline"
});

export const FIELD_LINE_WIDTH = Object.freeze({
  NONE: "none",
  THIN: "thin",
  MEDIUM: "medium",
  THICK: "thick"
});

export const FIELD_LINE_WIDTH_CODES = Object.freeze({
  NONE: 0,
  THIN: 1,
  MEDIUM: 2,
  THICK: 3
});
